import * as gs from "@ivanlog/gs";
import { CmpModalDialogBase } from "./tmpls";

export class CmpModalDialog extends CmpModalDialogBase {

    public static DialogOkNoCancel(text:string, title:string="Information")
    {
        const dialog = new CmpModalDialog();
        dialog.ctrls.lText.text = text;
        dialog.ctrls.lTitle.text = title;
        return dialog;
    }
    public static DialogOk(text:string, title:string="Information")
    {
        const dialog = CmpModalDialog.DialogOkNoCancel(text, title);
        dialog.ctrls.btnNo.hide();
        dialog.ctrls.btnCancel.hide();
        return dialog;
    }
    public static DialogOkNo(text:string, title:string="Information")
    {
        const dialog = CmpModalDialog.DialogOkNoCancel(text, title);
        dialog.ctrls.btnNo.show();
        dialog.ctrls.btnCancel.hide();
        return dialog;
    }

    private _resolve:Function;
    constructor() {
        super();
        this.ctrls.background.onclick = ()=>this._execute();
        this.ctrls.btnClose.onclick = ()=>this._execute();
        this.ctrls.btnCancel.onclick = ()=>this._execute();
        this.ctrls.btnOk.onclick = ()=>this._execute(true);
        this.ctrls.btnNo.onclick = ()=>this._execute(false);
        this.ctrls.lText.onclick = (e)=>e.stopPropagation();
    }

    public showAndWaitAsync(): Promise<boolean|undefined> {
        gs.q('body').first.append(this);
        return new Promise((resolve)=>{
            this._resolve=resolve;
        })
    }

    public show(){
        gs.q('body').first.append(this);
        super.show();
    }

    private _execute(result:boolean|undefined=undefined)
    {
        this.cut();
        if (this._resolve) this._resolve(result);
    }
}